import HttpClient from './http-client';
import {Response} from "./response/response";

export default class BaseService {
  async _exec(config, useResponseParser = true) {
    // config.validateStatus = function (statusCode) {
    //   return statusCode === 200;
    // };
    try {
      const response = await HttpClient.request(config);
      if (useResponseParser) {
        return new Response(response);
      }
      return response.data;
    } catch (e) {
      return this._handleAxiosErrors(config, e);
    }
  }

  _handleAxiosErrors(config, error) {
    if (error.response) {
      if (error.response.data) {
        return error.response.data;
      }
    }
    throw error;
  }
}



// WEBPACK FOOTER //
// ./src/network/base-service.js